import { Endpoint } from './enums';
import { DeferredPromise } from './deferred-promise';

export class DrRequestInfo {
    endpoint: Endpoint;
    data = null;
    responseName: string;

    constructor(value?: Partial<DrRequestInfo>) {
        if (value) {
            Object.assign(this, value);
        }
    }
}

export class DrWsRequestMessage {
    drWsClientContext: string;
    requestHandle: string;
    synchronousTimeout: string;
    contextHandle: string;

    constructor(data: any, contextHandle: string) {
        this.requestHandle = null;
        if (contextHandle) {
            this.contextHandle = contextHandle;
        }
        if (data) {
            Object.assign(this, data);
        }
    }
}

class RequestMessagePromise {
    url: Endpoint;
    data: string;
    promise: DeferredPromise<any>;

    constructor(value?: Partial<RequestMessagePromise>) {
        if (value) {
            Object.assign(this, value);
        }
    }
}

export class RequestMessagePromiseManager {

    private static _instance: RequestMessagePromiseManager;
    currentRequests: Array<RequestMessagePromise>;

    constructor() {
        this.currentRequests = new Array<RequestMessagePromise>();
    }

    public static get Instance(): RequestMessagePromiseManager {
        return this._instance || (this._instance = new this());
    }

    getRequest(url: Endpoint, data: string): RequestMessagePromise {
        const request = this.currentRequests.find(r => r.url === url && r.data === data);
        if (request && request.promise && request.promise.promise) {
            return request;
        }
    }

    addRequest(url: Endpoint, data: string, promise: DeferredPromise<any>): void {
        this.currentRequests.push(new RequestMessagePromise({ url: url, data: data, promise: promise }));
    }

    removeRequest(url: Endpoint, data: string): void {
        const existingRequestIndex = this.currentRequests.findIndex(r => r.url === url && r.data === data);
        if (existingRequestIndex >= 0) {
            this.currentRequests.splice(existingRequestIndex, 1);
        }
    }
}
